import React, { useState } from 'react';
import Loader from '../../../../components/misc/loader';
import { useScrollbarHide } from '../../../../hooks/useScrollbarHide';
import CheckoutTipsHeader from './tipsHeader';
import CheckoutTips from '../tips';
import CheckoutPayment from '../payment';
import CheckoutTotal from '../total';

const CheckoutTipsBill = ({
  restaurant,
  onPay,
  paymentOption,
  disabled,
  onOpenMenu,
  onFail,
  paymentKey,
}) => {
  useScrollbarHide(disabled);

  const [tipsAmount, setTipsAmount] = useState(0);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const isConfirmDisabled = () => {
    if (!tipsAmount) {
      return true;
    }

    if (
      restaurant.allowTipsWaiterSelect &&
      restaurant.mustSelectWaiterForTip &&
      restaurant.employees &&
      restaurant.employees.length > 0 &&
      !selectedEmployee
    ) {
      return true;
    }

    return false;
  };

  return (
    <div className="pt-6">
      <CheckoutTipsHeader onOpenMenu={onOpenMenu} />
      <CheckoutTips
        bill={{}}
        onChange={setTipsAmount}
        onChangeEmployee={(val) => setSelectedEmployee(val)}
        employees={restaurant.employees}
        allowWaiterSelect={restaurant.allowTipsWaiterSelect}
        preventSelectAllTeam={restaurant.mustSelectWaiterForTip}
        useFixed
        fromTipsCheckout
      />
      <CheckoutTotal total={tipsAmount} />
      <CheckoutPayment
        disabled={isConfirmDisabled()}
        paymentOption={paymentOption}
        onPay={({
          paymentType,
          paymentMethodId,
          dontDisable,
          paymentTrackId,
          paymentAccountId,
        }) => {
          onPay({
            paymentType,
            tips: tipsAmount,
            paymentMethodId,
            paymentAccountId,
            employeeId: selectedEmployee,
            dontDisable,
            paymentTrackId,
          });
        }}
        onFail={onFail}
        total={tipsAmount}
        paymentKey={paymentKey}
        restaurant={restaurant}
      />
      {disabled && (
        <div className="fixed z-10 bg-white opacity-80 top-0 bottom-0 left-0 right-0 h-full">
          <Loader />
        </div>
      )}
    </div>
  );
};

export default CheckoutTipsBill;
